import { ECheqRequestDetail } from "@/pages/requests/echeq/schema/echeq-requests.schema";
import { CheckRequestStatus } from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { v4 } from "uuid";
import { RequestStatusBadge } from "../badge/RequestStatusBadge";

interface Props {
  request?: ECheqRequestDetail | null;
}

export const ECheqRequestMainDataCard = ({ request }: Props) => {
  return (
    <Flex width="100%">
      <Flex
        flexDir="column"
        padding="12px"
        height="100%"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        borderRadius="12px"
        width="100%"
      >
        <Text
          className="amd-card-title"
          paddingBottom="16px"
          textTransform="uppercase"
          paddingX="24px"
        >
          Detalle
        </Text>

        <Grid width="100%" gap="0">
          {[
            {
              label1: "Fecha de solicitud",
              value1: dayjs(request?.fechaSolicitud).format("DD/MM/YYYY"),
              label2: "N° de Echeq",
              value2: request?.nroECheq ?? "-",
            },
            {
              label1: "Fecha de vencimiento",
              value1: request?.fechaVto ? dayjs(request?.fechaVto).format("DD/MM/YYYY") : "-",
              label2: "Fecha de emisión",
              value2: request?.fechaEmision ? dayjs(request?.fechaEmision).format("DD/MM/YYYY") : "-",
            },
            {
              label1: "Cuenta origen",
              value1: `${request?.titular ?? "-"} - ${request?.cuentaOrigen ?? "-"}`,
              label2: "ID Transacción",
              value2: request?.coelsaId ?? "-",
            },
            {
              label1: "Beneficiario CUIT/CUIL",
              value1: request?.cuitBeneficiario ?? "-",
              label2: "Estado",
              value2: (
                <RequestStatusBadge
                  status={request?.estado as CheckRequestStatus}
                  data-testid={"status-badge"}
                />
              ),
              value2Gap: "25px",
            },
          ].map((row, idx) => (
            <Grid
              key={v4()}
              templateColumns="repeat(2, 1fr)"
              bgColor={idx % 2 === 0 ? undefined : AppColors.WHITE_BORDER_1}
            >
              <GridItem paddingX="24px" paddingY="12px">
                <Text className="account-title-label">
                  {row.label1}:&nbsp;{row.value1}
                </Text>
              </GridItem>
              <GridItem paddingX="24px" paddingY="12px">
                <Flex gap={row.value2Gap ?? "0px"} alignItems="center">
                  <Text className="account-title-label">{row.label2}:</Text>
                  {typeof row.value2 === "string" ? (
                    <Text className="account-title-label">
                      &nbsp;{row.value2}
                    </Text>
                  ) : (
                    row.value2
                  )}
                </Flex>
              </GridItem>
            </Grid>
          ))}
        </Grid>
      </Flex>
    </Flex>
  );
};
